import { Trans, t } from '@lingui/macro';
import { Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { emails } from 'shared/domains/config';
import { StyledEmptyState } from './styled';
export function AssistantFeatureNotAvailable() {
    const emailHref = `mailto:${emails.support}`;
    return (<StyledEmptyState withAvatar icon={<Falcon icon="sparkles"/>} title={t({
            comment: 'Document assistant drawer - when feature is not enabled on the company - subtitle',
            message: 'Superpower your legal workflow',
        })} description={t({
            comment: 'Document assistant drawer - when feature is not enabled on the company - title',
            message: 'Power your legal work with Pocketlaw legal assistant',
        })} actions={<Button as="a" appearance="primary" href={emailHref}>
          <Trans comment="Document assistant drawer - when feature is not enabled on the company - button label">
            Contact sales
          </Trans>
        </Button>}/>);
}
